import { Typography, Popover, Modal, Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { MoreOutlined, EyeOutlined, DeleteOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { isMobileOnly } from 'react-device-detect';
import _ from 'lodash';
import { ReduxStore } from '../DocumentBoxesComponent';
import React, { useRef, useState } from 'react';
import DocViewer, { DocViewerRenderers } from 'react-doc-viewer';
const trash = require('../assets/trash.png');
const moreMenu = require('../assets/moreHorizontal.png');

const { Text } = Typography;

type Props = {
	clickTab: any;
	file: any;
	valuesData: any;
	modalDocument: any;
	env: any;
	platform: string;
};

const RenderFiles = ({ clickTab, file, valuesData, modalDocument, env, platform }: Props) => {
	const { t } = useTranslation();
	const firstButtonRefs = useRef<{ [key: string]: HTMLButtonElement | null }>({});
	const secondButtonRefs = useRef<{ [key: string]: HTMLButtonElement | null }>({});
	const popoverButtonRefs = useRef<{ [key: string]: HTMLButtonElement | null }>({});
	const userToken = useSelector<ReduxStore, string>((state) => state.auth.token);
	const [modalView, setModalView] = React.useState<boolean | false>(false);
	const [url, setUrl] = React.useState<any | undefined>(undefined);
	const [mime, setMime] = React.useState<any | undefined>(undefined);
	const [fileData, setFileData] = React.useState<any | undefined>(undefined);

	const loadSignedDocument = async (documentId: any) => {
		const response = await axios.get(`${env.api.url}/v1/documents/get-document-url/${documentId}`, {
			headers: { Authorization: `Bearer ${userToken}` }
		});

		const responseFile = await axios.get(response.data.data.url, {
			responseType: 'blob'
		});

		return {
			...response.data.data,
			fileData: responseFile.data
		};
	};

	const handleFileDownload = async (document: any) => {
		if (!document.tags.includes('automatic')) {
			axios
				.get(`${env.api.url}/v1/documents/get-document-url/${document.id}?token=${userToken}`, {
					headers: { Authorization: `Bearer ${userToken}` }
				})
				.then((response) => {
					if (response.data.success) {
						window.open(response.data.data.url, '_blank'); //to open new page
					}
				})
				.catch((error) => {});
		} else {
			const { url, name, mime, fileData } = await loadSignedDocument(document.id);
			setUrl(url);
			setMime(mime);
			setFileData(fileData);
			setModalView(true);
		}
	};

	const content = (item: any) => {
		return (
			<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
				<Button
					type="text"
					className="see-document"
					icon={<EyeOutlined />}
					ref={(el) => (firstButtonRefs.current[item.id] = el)}
					onClick={() => handleFileDownload(item)}
					onKeyDown={(e) => {
						if (e.key === 'Tab') {
							e.preventDefault();
							secondButtonRefs.current[item.id]?.focus();
						}
					}}
					style={{ border: 'none', boxShadow: 'none', padding: 0 }}>
					{t('doc.seeNew')}
				</Button>
				<Button
					ref={(el) => (secondButtonRefs.current[item.id] = el)}
					className="delete-document"
					icon={
						platform === 'engel' || platform === 'safecredit' ? (
							<img src={trash} alt="trash" width={17} style={{ marginLeft: -2 }} />
						) : (
							<DeleteOutlined />
						)
					}
					onClick={() => modalDocument(item.id)}
					onKeyDown={(e) => {
						if (e.key === 'Tab') {
							e.preventDefault();
							popoverButtonRefs.current[item.id]?.focus();
						}
					}}
					style={{ border: 'none', boxShadow: 'none', padding: 0 }}>
					{t('loan.delete')}
				</Button>
			</div>
		);
	};

	const array: any[] = [];
	valuesData.map((item: any) => {
		if (item.type === file?.name && item.owner === clickTab) {
			array.push(
				<div
					style={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'space-between',
						gap: 4
					}}
					key={_.uniqueId('render_file')}>
					<div>
						<Text
							style={{
								color:
									platform === 'engel'
										? '#666666'
										: platform === 'sabadell'
										? '#424242'
										: '#748EA0',
								fontSize: 12,
								fontWeight: 400
							}}>
							{item.type === 'consent_sabadell' && platform === 'sabadell' ? (
								<>
									{item.name
										.replace('Consentimiento_de_datos_Sabadell', 'Tratamiento_de_datos')
										.substr(0, 20)}
									...
								</>
							) : (
								<>{item?.name.substr(0, 20)}...</>
							)}
						</Text>
					</div>
					<Popover
						trigger="click"
						content={content(item)}
						overlayStyle={{ width: isMobileOnly ? '32vw' : undefined }}
						onOpenChange={(open) => {
							if (open) {
								setTimeout(() => firstButtonRefs.current[item.id]?.focus(), 0);
							}
						}}>
						<Button
							tabIndex={0}
							ref={(el) => (popoverButtonRefs.current[item.id] = el)}
							style={{ border: 'none', padding: 0, boxShadow: 'none', marginTop: -4 }}
							aria-label="Más opciones">
							{platform === 'engel' ? (
								<MoreOutlined
									style={{ transform: 'rotate(90deg)', fontSize: 22, cursor: 'pointer' }}
								/>
							) : (
								<MoreOutlined color="#748EA0" style={{ fontWeight: 500 }} />
							)}
						</Button>
					</Popover>
				</div>
			);
		}

		if (_.isNil(item.type) && item.owner === clickTab && file.name === 'docs.othersDocs') {
			array.push(
				<div
					className="wrapper-flex"
					style={{ justifyContent: 'space-between' }}
					key={_.uniqueId('render_file')}>
					<div>
						<Text style={{ color: '#748EA0', fontSize: 12, fontWeight: 400 }}>
							{item?.name.substr(0, 20)}...
						</Text>
					</div>

					<div
						style={{
							width: 20,
							height: 20,
							textAlign: 'center',
							marginRight: platform === 'engel' && 16
						}}>
						<Popover
							trigger="hover"
							content={content(item)}
							overlayStyle={{
								width: isMobileOnly ? '30vw' : undefined
							}}>
							{platform === 'engel' ? (
								<img src={moreMenu} alt="more" style={{ cursor: 'pointer' }} />
							) : (
								<MoreOutlined color="#748EA0" style={{ fontWeight: 500 }} />
							)}
						</Popover>
					</div>
				</div>
			);
		}
	});
	return (
		<>
			{array}
			{mime && url && fileData && (
				<Modal
					className="ModalDesktopCert"
					width={800}
					open={modalView}
					onOk={() => setModalView(!modalView)}
					okText={t('m_common.close')}
					okButtonProps={{
						className: platform === 'engel' ? 'button-primary-engel' : 'button-primari-gibobs',
						style: { margin: '0 auto', marginTop: 24 }
					}}
					cancelButtonProps={{ style: { display: 'none' } }}
					onCancel={() => setModalView(!modalView)}>
					<DocViewer
						className="doc-view-modal"
						style={{ height: '70vh' }}
						pluginRenderers={DocViewerRenderers}
						documents={[{ uri: url, fileType: mime, fileData: fileData }]}
					/>
				</Modal>
			)}
		</>
	);
};

export default RenderFiles;
